import { render } from "./Spheres.vue?vue&type=template&id=39d3788a&scoped=true"
import script from "./Spheres.vue?vue&type=script&lang=js"
export * from "./Spheres.vue?vue&type=script&lang=js"

import "./Spheres.vue?vue&type=style&index=0&id=39d3788a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d3788a"]])

export default __exports__